import qmusicFonts from '@dpgradio/creative/styles/fonts/qmusic.css?inline'

// @font-face rules inside a shadow root are ignored, so the fonts have to live on the document.
export function registerFonts() {
  if (isFontDefined('Cervo')) return

  const style = document.createElement('style')
  style.textContent = qmusicFonts
  document.head.appendChild(style)
}

// document.fonts.check() returns true when no font face matches at all, so look the family up instead.
function isFontDefined(family) {
  return [...document.fonts].some((fontFace) => fontFace.family.replace(/["']/g, '') === family)
}
